import {Component, OnInit, ViewChild, ViewContainerRef} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {ElementOptions, ElementsOptions, StripeCardComponent, StripeService} from "ngx-stripe";
import {Restaurant} from "../../shared/model/restaurant";
import {ActivatedRoute, Router} from "@angular/router";
import {Overlay} from "angular2-modal";
import {Modal} from "angular2-modal/plugins/bootstrap";
import {validateEmail} from "../../shared/validators/validate-email";
import {Source} from "../../shared/model/source";
import {LocalStripeService} from "../../shared/services/stripe/local.stripe.service";



@Component({
  selector: 'app-credit-card-edit',
  templateUrl: './credit-card-edit.component.html',
  styleUrls: ['./credit-card-edit.component.css']
})
export class CreditCardEditComponent implements OnInit {
   theCard: string;

  private noSources: any;

   restaurant:Restaurant;
  private customer_id:string;
   showCreditCardError:boolean;
  private ccerror:string;
  private passedSource:Source;


  @ViewChild(StripeCardComponent) card: StripeCardComponent;

  cardOptions: ElementOptions = {
    iconStyle: 'solid',
    style: {
      base: {
        iconColor: '#8898AA',
        color: '#0f0f71',
        lineHeight: '15px',
        fontWeight: 300,
        fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
        fontSize: '15px',

        '::placeholder': {
          color: '#8898AA',
        },
      },
      invalid: {
        iconColor: '#e85746',
        color: '#e85746',
      }
    },
  };


  elementsOptions: ElementsOptions = {
    locale: 'en' // TODO : Make this flexible to show other languages
  };

  form: FormGroup;


  constructor(
    private fb: FormBuilder,
    private stripeService: StripeService,
    private localStripeService: LocalStripeService,
    public modal: Modal,
    overlay: Overlay,
    vcRef: ViewContainerRef,
    private route: ActivatedRoute,
    private router: Router
  ) {

    route.data
      .subscribe( ( data : {restaurant:Restaurant  }) =>
        {
          this.restaurant = data.restaurant;
        }

      )
  }

  ngOnInit() {

    this.showCreditCardError = false;
    this.ccerror = '';

    this.form = this.fb.group({
      name: ['', [Validators.required,Validators.minLength(3)]],
      line1:['',[Validators.required,Validators.minLength(7)]],
      city:['',[Validators.required,Validators.minLength(3)]],
      email:['',[Validators.required, validateEmail]],

    });

    let thisRestaurantId = this.restaurant.$key;

    // console.log(thisRestaurantId);

    this.localStripeService.getBillingInfo(thisRestaurantId)
      .subscribe(  billInfo   =>{
        // console.log(billInfo);
        this.customer_id = billInfo.id;
        this.localStripeService.getSources(billInfo.id).subscribe( stripeSource => {
          this.noSources = stripeSource.length == 0;
          // console.log(stripeSource[0]);

          // console.log(this.noSources);

          let source = Source.fromJson(stripeSource[0]);
          this.initializeForm(source);
          this.passedSource = source;
          this.theCard = source.card.brand+ "  **** **** **** "+source.card.last4+" Exp. "+source.card.exp_month+"/"+source.card.exp_year;
          // console.log(this.theCard);

        })

      });

  }

  initializeForm(source: Source) {
    // console.info("Passed Source!!!!!!");
    // console.log(source);
    this.form.controls["name"].setValue(source.owner.name) ;
    this.form.controls["line1"].setValue(source.owner.address.line1);
    this.form.controls["city"].setValue(source.owner.address.city);
    this.form.controls["email"].setValue(source.owner.email);


  }

  /**
  *
  *
  * TODO: Add more Subscript with discount for multiple months payment
  * TODO: Keep multiple payment sources
  * TODO: Add Bank accounts as payment sources
  * TODO: Accept Cupons
  *
  * */

  save(form) {
    // console.log("Showing Form Values ");
      // console.log(form);
      if (form.invalid){
        this.showErrors();
      } else {
        this.showCreditCardError = false;
        this.ccerror = '';
        this.stripeService
          .createSource(this.card.getCard(),{
            type: 'card',
            currency : 'usd', // TODO : Make this flexible to accept other currencies
            owner:{
              email : form.value.email,
              name : form.value.name,
              address : {
                city : form.value.city,
                country :'US', // TODO : Make this flexible to accept other countries
                line1 : form.value.line1,
                line2 : null,
                postal_code :  null,
                state : null
              }
            },
          })
          .subscribe(result => {
            if (!result.error) {
              // Use the token to create a charge or a customer
              // https://stripe.com/docs/charges
              // console.log("Showing Result ");
              // console.log(result);
              // console.log(result.source.id);
              // console.log(this.passedSource.id);
              this.updateCustomerSource(this.customer_id,result.source.id,this.passedSource.id);

            } else if (result.error) {
              // Error creating the token
              // console.log("There was an Error");
              this.showErrors();
              this.showCreditCardError = true;
              this.ccerror = result.error.message;
              // console.log(result.error.message);
            }
          });
      }
    }

  private updateCustomerSource(customerId,sourceId,oldSourceid){
    const sourceToCustomer$ = this.localStripeService.updateCustomerSource(customerId,sourceId,oldSourceid);
    sourceToCustomer$
      .subscribe(() => {
          this.navigateToAccountingPage();
        }
        ,err => this.messageIt('Error adding source ',err))


  }

  private navigateToAccountingPage() {
    let restaurantId = this.restaurant.$key;

    let navigateRoute = './restaurants/'+ restaurantId

    navigateRoute = navigateRoute +'/edit';

    this.router.navigate([navigateRoute], {queryParams:{view:'Account'}});


  }

  messageIt(titleP:string,messageP:string){

    this.modal.alert()
      .size('lg')
      .showClose(true)
      .title(titleP)
      .body(messageP)
      .open();
  }

  isErrorVisible(field:string,error:string){

    return this.form.controls[field].dirty && this.form.controls[field].errors && this.form.controls[field].errors[error];

  }

  cancel() {
    let restaurantId = this.restaurant.$key;

    let navigateRoute = './restaurants/'+ restaurantId

    navigateRoute = navigateRoute +'/edit';

    this.router.navigate([navigateRoute], {queryParams:{view:'Account'}});
  }

  showErrors(){

    for (let element in this.form.controls){
      for(let element1 in  this.form.controls[element].errors){
        this.form.controls[element].markAsDirty();
      }
    }
  }

  reset() {
    this.form.reset();

  }

  isEmailValid():boolean{
    return !this.form.controls['email'].errors
  }

  showEmailErrors(){
    if (this.form.controls['email'].errors){
      this.form.controls['email'].markAsDirty();
    }

  }






}



// WEBPACK FOOTER //
// ./src/app/credit-card/credit-card-edit/credit-card-edit.component.ts